module.exports = __webpack_public_path__ + "static/media/pitchNoData.72540b57.svg";